import React, { FC, useEffect } from 'react';
import { useController, useWatch } from 'react-hook-form';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Button from '../../../../../components/button/index';
import { EquityPlanCombobox } from '../../components/index';
import { ChildrenFormProps } from '../../event-form.types';
import { GrantSignatureOption } from '../../event-form.validation';

export const BulkGrantStepFirst: FC<ChildrenFormProps> = ({
  companyId,
  control,
  handleCloseModal,
  nextFormStep,
  prevFormStep,
  setFormData,
}) => {
  const sharePlan = useWatch({
    control,
    name: 'stepOne.eventDetails.grant.sharePlan',
    defaultValue: undefined,
  });
  const equityPlanId = sharePlan?.id ?? '';
  const { field: signatureField } = useController({
    control,
    name: 'stepOne.eventDetails.grant.signatureOption',
  });

  const hasPlan = Boolean(equityPlanId?.trim());

  useEffect(() => {
    if (hasPlan && signatureField.value !== GrantSignatureOption.WITHOUT_SIGNATURE) {
      setFormData(
        'stepOne.eventDetails.grant.signatureOption',
        GrantSignatureOption.WITHOUT_SIGNATURE,
      );
    }
  }, [hasPlan, setFormData, signatureField.value]);

  const canProceed = hasPlan && signatureField.value === GrantSignatureOption.WITHOUT_SIGNATURE;

  return (
    <>
      <div className="invisible-y-scroll flex h-full flex-col gap-6 rounded-b-xl border-b border-gray-300 bg-white p-6 pt-0">
        <section className="flex flex-col">
          <div className="flex flex-col gap-2 rounded-lg border border-gray-100 p-4 shadow-sm">
            <label className="text-xs font-[450] text-gray-500">
              <AppFormattedMessage id="EQUITY_PLAN" />
            </label>
            <EquityPlanCombobox companyId={companyId} control={control} />
          </div>
          <p className="px-4 py-3 text-xs text-gray-500">
            <AppFormattedMessage id="EQUITY_PLAN_SIGNATURE_HELPER" />
          </p>
        </section>

        <div className="rounded-md bg-sunbeam-50 px-3 py-2 text-xs font-[450] text-gray-800">
          Bulk import only creates grants without sending them for signature. To send grants for
          signature, please edit the Grant Event after the import is completed.
        </div>

        {/* {hasPlan && (
          <div className="flex flex-col gap-3">
            <label className="pl-3.5 text-sm font-[450] text-gray-700">
              <AppFormattedMessage id="SIGNATURE" />
            </label>
            <div className="flex flex-col gap-4 rounded-md border border-gray-50 p-4 shadow-sm">
              <OptionCard
                description={<AppFormattedMessage id="GRANT_WITHOUT_SIGNATURE_DESCRIPTION" />}
                icon={
                  <CheckCircleIcon
                    className="size-6"
                    iconColor={
                      signatureField.value === GrantSignatureOption.WITHOUT_SIGNATURE
                        ? '#2565C8'
                        : '#344054'
                    }
                  />
                }
                isSelected={signatureField.value === GrantSignatureOption.WITHOUT_SIGNATURE}
                onClick={handleProceedWithoutSignature}
                title={<AppFormattedMessage id="ADD_WITHOUT_SIGNATURE" />}
              />
            </div>
          </div>
        )} */}
      </div>

      <div className="flex h-9 w-full justify-between gap-3 px-6">
        <Button
          className="w-fit bg-transparent px-4 py-[6px] text-sm font-[450] text-gray-700"
          onClick={handleCloseModal}
          styleType="NONE"
          type="button"
        >
          <AppFormattedMessage id="CANCEL" />
        </Button>
        <div className="flex gap-3">
          <Button
            className="h-full w-fit rounded border border-gray-100 bg-white px-3 py-[6px] text-sm font-[450] text-gray-700"
            onClick={prevFormStep}
            styleType="NONE"
            type="button"
          >
            <AppFormattedMessage id="BACK" />
          </Button>
          <Button
            className="h-full w-fit px-4 py-[6px] text-sm font-[550] text-white"
            disabled={!canProceed}
            onClick={nextFormStep}
            type="button"
          >
            <AppFormattedMessage id="NEXT" />
          </Button>
        </div>
      </div>
    </>
  );
};
